import { useRouteMatch, Switch } from "react-router-dom";
import React from "react";
import { useSelector } from "react-redux";
import { PrivateRoute } from "../../components/PrivateRoute";
import { Applications } from "./applications";
import { ApplicationDetail } from "./detail";
import { ApplicationsOverview } from "./applicationsOverview";
import { selectOrg } from "../../models/organization/organizationSlice";
import { selectMyUser } from "../../models/users/myUserSlice";

export const ApplicationRouter = () => {
  const { path } = useRouteMatch();
  const org = useSelector(selectOrg);
  const myUser = useSelector(selectMyUser);

  return (
    <Switch>
      <PrivateRoute exact path={`${path}`}>
        <Applications />
      </PrivateRoute>
      <PrivateRoute exact path={`${path}/overview`}>
        <ApplicationsOverview
          fiSlug={org?.slug}
          userId={myUser?.userId}
        />
      </PrivateRoute>
      <PrivateRoute path={`${path}/:applicationId`}>
        <ApplicationDetail />
      </PrivateRoute>
    </Switch>
  );
};
